'use client'

import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk'
import { useEffect, useState } from 'react'

import type { ClientFlags } from '@mntn-dev/flags-types'

import { useSessionFlags } from './use-session-flags.ts'

const useFlags = () => {
  const ldFlags = useLDFlags<ClientFlags>()
  const [flags, setFlags] = useState(ldFlags)
  const sessionFlags = useSessionFlags(flags)

  // Merge session storage flags with the ld flags on the client after page load to avoid
  // "Hydration failed because the initial UI does not match what was rendered on the server." errors.
  useEffect(() => {
    setFlags({ ...ldFlags, ...sessionFlags })
  }, [ldFlags, sessionFlags])

  return flags
}

export default useFlags
